const { NOT_ACCEPTED_RULES_IDS } = require("constants/rules");

export const checkIfRulesAreAccepted = ({ error, notify, alert, navigate }) => {
  const allErrors = error?.response?.data?.errors || error?.errors;

  const errorCodeExists = allErrors?.find((error) =>
    Object.keys(NOT_ACCEPTED_RULES_IDS).includes(error.type?.toString())
  );
  if (errorCodeExists) {
    alert({
      text: error?.response?.data?.message || error?.message,
      variant: "error",
      button: "تایید قوانین",
      onClose: () => {
        navigate(NOT_ACCEPTED_RULES_IDS[errorCodeExists.type]);
      },
    });
  } else {
    notify(
      error?.response?.data?.message ||
        error?.response?.message ||
        error?.message,
      "error"
    );
  }
};
